export function toggleVideoSound() {
  const video = document.getElementById('video');

  this.classList.toggle('on');

  video.muted = !(video.muted)
}